import { render, staticRenderFns } from "./CompNoData.vue?vue&type=template&id=c1f54e6a&scoped=true"
import script from "./CompNoData.vue?vue&type=script&lang=js"
export * from "./CompNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f54e6a",
  null
  
)

export default component.exports